import Sidebar from '../components/Sidebar';
import ProductThumbnail from '../components/ProductThumbnail';
import CollectionFilters from '../components/CollectionFilters';
import NavMobileFilters from '../components/NavMobileFilters';

export default class Search {
  constructor(section) {
    this.el = section.el;
    this.settings = section.data;

    this.collectionFilters = this.el.querySelector('[data-collection-filters]');
    this.mobileFiltersMenu = this.el.querySelector('[data-mobile-filters]');
    this.sidebarDesktopEl = this.el.querySelector('[data-sidebar-desktop]');

    this.desktopCollectionFiltersEl = this.el.querySelector('[data-faceted-search-desktop]');
    this.mobileCollectionFiltersEl = this.el.querySelector('[data-faceted-search-mobile]');

    this.desktopCollectionFilters = new CollectionFilters(this.desktopCollectionFiltersEl);
    this.mobileCollectionFilters = new CollectionFilters(this.mobileCollectionFiltersEl);

    this.productThumbnailsElements = this.el.querySelectorAll('[data-product-thumbnail]');
    this.productThumbnails = [];
    const thumbnailSettings = {
      showSecondaryMediaOnHover: this.settings.show_secondary_media,
    };

    if (this.mobileFiltersMenu) {
      this.mobileFilters = new NavMobileFilters({
        controls: this.collectionFilters,
        mobileNav: this.mobileFiltersMenu,
      });
    }

    this.sidebar = new Sidebar(this.sidebarDesktopEl);
    this.productThumbnailsElements.forEach(productThumbnail => {
      this.productThumbnails.push(new ProductThumbnail(productThumbnail, thumbnailSettings));
    });
  }

  onSectionUnload() {
    this.sidebar.unload();
    if (this.mobileFilters) {
      this.mobileFilters.unload();
    }
    this.productThumbnails.forEach(productThumbnail => productThumbnail.unload());
    this.desktopCollectionFilters.unload();
    this.mobileCollectionFilters.unload();
  }
}
